module.exports = __webpack_public_path__ + "media/images/global/guests-483293606aca7d990cb1f141917e7249.png";